import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ServicesCitiesWrapper } from "./styled";
import { Box, ButtonDays, HeadingStyled } from "../styled/Elements";

/**
 * Service / operate-in cities, plus registration city when operate-in is empty
 * or registration city is not already in the list.
 */
const ServicesCities = ({ cities, registrationCity }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const displayCities = useMemo(() => {
    const list = Array.isArray(cities) ? [...cities] : [];
    const reg = registrationCity;
    if (!reg) {
      return list;
    }

    const nameEn =
      typeof reg === "string"
        ? reg.trim()
        : String(reg.name_en || reg.city_name || "").trim();
    const nameAr =
      typeof reg === "string"
        ? reg.trim()
        : String(reg.name_ar || reg.city_name || nameEn).trim();

    if (!nameEn && !nameAr) {
      return list;
    }

    const alreadyPresent = list.some((item) => {
      const en = String(item?.name_en || "").trim().toLowerCase();
      const ar = String(item?.name_ar || "").trim().toLowerCase();
      return (
        (nameEn && (en === nameEn.toLowerCase() || ar === nameEn.toLowerCase())) ||
        (nameAr && (en === nameAr.toLowerCase() || ar === nameAr.toLowerCase()))
      );
    });

    if (alreadyPresent) {
      return list;
    }

    return [
      {
        id: reg?.id ?? null,
        name_en: nameEn || nameAr,
        name_ar: nameAr || nameEn,
      },
      ...list,
    ];
  }, [cities, registrationCity]);

  return (
    <ServicesCitiesWrapper>
      <HeadingStyled size="24px">{t("OurServicesInclude")}</HeadingStyled>
      <Box className="w-100 d-flex gap-2 mt-2 citiesBtns">
        {displayCities.length > 0 &&
          displayCities.map((item, key) => (
            <Box key={item?.id != null ? `city-${item.id}` : `city-name-${key}`}>
              <ButtonDays
                weight="lighter"
                className="{`day-button`}"
                type="button"
                padding="6px 10px"
                color="var(--darkGrey)"
              >
                {language === "en" ? item?.name_en : item?.name_ar}
              </ButtonDays>
            </Box>
          ))}
      </Box>
    </ServicesCitiesWrapper>
  );
};

export default ServicesCities;
